import { CacheKey } from '@wix/wixstores-client-core';
import { CACHE_TTL_MS, SPECS } from '../../constants';
var ClientConfigStorage = /** @class */ (function () {
    function ClientConfigStorage(_a) {
        var storage = _a.storage, siteStore = _a.siteStore;
        var _this = this;
        this.storage = storage;
        this.siteStore = siteStore;
        if (this.siteStore.experiments.enabled(SPECS.OnlineStoresSessionStorageWithTTL)) {
            this.clearOnReload();
            this.siteStore.location.onChange(function () {
                _this.storage.session.setItem(_this.getLastUrlCacheKey(), _this.siteStore.location.url);
            });
        }
    }
    ClientConfigStorage.prototype.get = function () {
        if (this.siteStore.experiments.enabled(SPECS.OnlineStoresSessionStorageWithTTL)) {
            var item = this.storage.session.getItem(CacheKey.GET_CONFIG);
            if (!item) {
                return null;
            }
            try {
                var parsed = JSON.parse(item);
                var isExpired = Date.now() - parsed.timestamp > CACHE_TTL_MS;
                if (isExpired) {
                    this.clear();
                    return null;
                }
                return parsed.item;
            }
            catch (_a) {
                return null;
            }
        }
        return this.storage.memory.getItem(CacheKey.GET_CONFIG);
    };
    ClientConfigStorage.prototype.set = function (data) {
        if (this.siteStore.experiments.enabled(SPECS.OnlineStoresSessionStorageWithTTL)) {
            var cachedItem = {
                timestamp: Date.now(),
                item: data,
            };
            this.storage.session.setItem(CacheKey.GET_CONFIG, JSON.stringify(cachedItem));
        }
        else {
            this.storage.memory.setItem(CacheKey.GET_CONFIG, data);
        }
    };
    ClientConfigStorage.prototype.clear = function () {
        this.storage.session.removeItem(CacheKey.GET_CONFIG);
    };
    ClientConfigStorage.prototype.clearOnReload = function () {
        var lastUrlCacheKey = this.getLastUrlCacheKey();
        var url = this.siteStore.location.url;
        var isReload = url === this.storage.session.getItem(lastUrlCacheKey);
        if (isReload) {
            this.clear();
            this.storage.session.removeItem(lastUrlCacheKey);
        }
        this.storage.session.setItem(lastUrlCacheKey, url);
    };
    ClientConfigStorage.prototype.getLastUrlCacheKey = function () {
        return "".concat(CacheKey.GET_CONFIG, "-lastUrl");
    };
    return ClientConfigStorage;
}());
export { ClientConfigStorage };
//# sourceMappingURL=ClientConfigStorage.js.map